import { useAtom, WritableAtom } from 'jotai';
import React, { SetStateAction } from 'react';
import { FilterChip } from './FilterChip';
import { useTranslation } from 'react-i18next';
import {
  getLabelBaseOnSubscriptionStatus,
  SubscriptionStatus,
} from '../SubscriptionStatus/constants/subscriptionStatus';

type SubscriptionStatusChipsProps = {
  subscriptionStatusAtom: WritableAtom<
    SubscriptionStatus[],
    [SetStateAction<SubscriptionStatus[]>],
    void
  >;
};

export const SubscriptionStatusChips = ({
  subscriptionStatusAtom,
}: SubscriptionStatusChipsProps) => {
  const { t } = useTranslation();
  const [subscriptionStatuses, setSubscriptionStatus] = useAtom(subscriptionStatusAtom);

  const onClear = (status: SubscriptionStatus) => {
    setSubscriptionStatus((currentMNOStatus) =>
      currentMNOStatus.filter((mnoStatus) => mnoStatus !== status),
    );
  };

  if (subscriptionStatuses.length === 0) {
    return null;
  }

  return (
    <>
      {subscriptionStatuses.map((status) => {
        return (
          <React.Fragment key={status}>
            <FilterChip
              text={`${t('simInventory.subscriptionStatus')}: ${getLabelBaseOnSubscriptionStatus(
                status,
                t,
              )}`}
              onClose={() => {
                onClear(status);
              }}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};
